import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Labour} from '../models/labour/labour.model';
import {JobLabour} from '../models/labour/jobLabour.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LabourService {

  constructor(private http: HttpClient) {
  }

  private LABOUR_URL: string = environment.BASE_URL + 'labour';
  private JOB_LABOUR_URL: string = environment.BASE_URL + 'job';

  /**
   * GETS
   */
  public getLabours(): Observable<Labour[]> {
    return this.http.get<Labour[]>(`${this.LABOUR_URL}`).pipe(map(
      labours => labours.sort((l1, l2) => l1.name.localeCompare(l2.name))
    ));
  }

  public getJobLabour(id: string): Observable<JobLabour> {
    return this.http.get<JobLabour>(`${this.JOB_LABOUR_URL}/${id}/labour`).pipe();
  }

  public getLabour(id: string): Observable<Labour> {
    return this.http.get<Labour>(`${this.LABOUR_URL}/${id}`).pipe(
    );
  }

  /**
   * CREATES
   */
  public createLabour(engine: Labour): Observable<Labour> {
    return this.http.post<Labour>(`${this.LABOUR_URL}`, engine).pipe();
  }


  /**
   * UPDATES
   */
  public updateLabour(engine: Labour): Observable<Labour> {
    return this.http.patch<Labour>(`${this.LABOUR_URL}/${engine.id}`, engine).pipe();
  }

  public updateJobLabour(jobLabour: JobLabour): Observable<JobLabour> {
    return this.http.patch<JobLabour>(`${this.JOB_LABOUR_URL}/${jobLabour.id}/labour`, jobLabour).pipe();
  }

  /**
   * DELETE
   */
  public deleteLabour(id: string): Observable<Labour> {
    return this.http.delete<Labour>(`${this.LABOUR_URL}/${id}`).pipe();
  }

}
